<template>
  <div>
    <div v-if="authenticated">
      <button v-if="!isMobile && isUploadEnabled && shareButton"
              class="navbar-buttons share-btn-dimensions uk-button add-pointer"
              @mouseover="resolveHover(true)"
              @mouseleave="resolveHover(false)"
              @click="shareResource">
        <img v-if="!hover" class="share-icon" :src="whiteShareIcon">
        <img v-else class="share-icon" :src="blueShareIcon">
        {{$t('general.shareAResource')}}
      </button>
      <div class="uk-inline">
        <img v-if="userProfile.profilePicture" class="avatar-img avatar-img-custom" :src="userProfile.profilePicture">
        <img v-else class="avatar-img avatar-img-default" :src="genericAvatar">
        <div id="profile-dropdown" class="user-profile-dropdown"
             uk-dropdown="pos: bottom-right; mode: click; delay-hide:0">
          <ul class="uk-nav uk-dropdown-nav">
            <div class="user-profile"
                 @mouseover="profileHover(true)"
                 @mouseleave="profileHover(false)"
                 @click="redirect(IdAccountUrl, '_blank')">
              <li class="user-name">{{userProfile.userName}}<img class="edit-icon" :src="editIcon"></li>
              <li class="link-text">{{userProfile.email}}</li>
            </div>
            <li v-if="shareButton && !isMobile && isUploadEnabled" class="menu-text" @click="shareResource"><a>{{$t('general.shareAResource')}}</a>
            </li>
            <li v-if="shareButton && !isMobile" class="menu-text" @click="manageResources"><a>{{$t('userProfile.manageMyResources')}}</a>
            </li>
            <li v-if="shareButton" class="menu-text" @click="redirect(support, '_blank')"><a>{{$t('general.help')}}</a>
            </li>
            <li v-if="shareButton" class="menu-text" @click="redirect(seePage, '_blank')"><a>{{$t('userProfile.joinEducator')}}</a>
            </li>
            <li v-if="shareButton" class="menu-text" @click="redirect(feedBackUrl, '_blank')"><a>{{$t('userProfile.feedback')}}</a>
            </li>
            <li class="menu-text debug-panel" v-if="$feature('debug').enabled" @click="openPanel"><a>Debug</a></li>
            <li class="menu-text" @click="logout"><a>{{$t('general.signOut')}}</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else id="SignIn">
      <button v-if="!isMobile && isUploadEnabled" class="navbar-buttons share-btn-dimensions uk-button add-pointer"
              @mouseover="resolveHover(true)"
              @mouseleave="resolveHover(false)"
              @click="shareResource">
        <img v-if="!hover" class="share-icon" :src="whiteShareIcon">
        <img v-else class="share-icon" :src="blueShareIcon">
        {{$t('general.shareAResource')}}
      </button>
      <button class="navbar-buttons signin-btn-dimensions uk-button add-pointer" @click="login($route.fullPath)">
        {{$t('general.signIn')}}
      </button>
    </div>
    <leave-page-modal
      :id="leaveUserProfile"
      @leave-page="leavePage">
    </leave-page-modal>
  </div>
</template>
<script>
  import {mapGetters, mapMutations} from 'vuex'
  import * as url from '../../enums/static-urls'
  import iconUtil from '../../utils/icon-util'
  import * as misc from '../../enums/misc'
  import * as routes from '../../enums/routes'
  import device from '../../utils/device-detection-util'
  import UIkit from 'uikit'
  import Router from '../../router/index'
  import leavePageModal from '../ui-components/modals/leave-page'
  import { UPLOAD_CONTENT_SMEX } from '@/plugins/feature/feature-list'

  export default {
    name: 'user-profile',
    props: ['userProfile', 'shareButton'],
    components: {
      leavePageModal
    },
    data() {
      return {
        'genericAvatar': iconUtil.resolve(misc.GENERIC_AVATAR),
        whiteShareIcon: iconUtil.resolve(misc.SHARE_ICON_WHITE),
        blueShareIcon: iconUtil.resolve(misc.SHARE_ICON_BLUE),
        hover: false,
        shareResourcePage: window.location.pathname === routes.SHARE_RESOURCE,
        isMobile: device.isMobile(),
        newRoute: null,
        leaveUserProfile: 'leave-user-profile',
        editIcon: iconUtil.resolve(misc.EDIT_PEN),
        IdAccountUrl: url.ID_ACCOUNT,
        feedBackUrl: url.FEEDBACK_LINK,
        seePage: url.SMART_EXEMPLARY_EDUCATOR,
        support: url.SUPPORT
      }
    },
    computed: {
      ...mapGetters('auth/id', ['authenticated']),
      ...mapGetters(['getResourceDataAdded']),
      isUploadEnabled() {
        return this.$feature(UPLOAD_CONTENT_SMEX.name).enabled
      }
    },
    methods: {
      ...mapMutations(['setResourceDataAdded', 'clearFeatures']),
      openPanel() {
        UIkit.modal('#debug-panel').show()
      },
      login(route) {
        let state = {
          from: route,
          download: false
        }
        this.$auth.id.signIn(state)
      },
      logout() {
        if (window.location.pathname === routes.SHARE_RESOURCE) {
          if (this.getResourceDataAdded) {
            this.newRoute = routes.HOME
            UIkit.modal('#leave-user-profile').show()
          } else {
            this.$auth.id.signOut()
            Router.push(routes.HOME)
            this.clearFeatures()
          }
        } else {
          this.$auth.id.signOut()
          Router.push(routes.HOME)
          this.clearFeatures()
        }
      },
      shareResource() {
        if (!this.authenticated) {
          this.login(routes.SHARE_RESOURCE)
        } else {
          if (window.location.pathname === routes.SHARE_RESOURCE) {
            if (this.getResourceDataAdded) {
              this.newRoute = routes.SHARE_RESOURCE
              UIkit.modal('#leave-user-profile').show()
            } else {
              window.location.reload()
            }
          } else {
            UIkit.dropdown('#profile-dropdown').hide()
            Router.push(routes.SHARE_RESOURCE)
          }
        }
      },
      resolveHover(hover) {
        this.hover = hover
      },
      manageResources() {
        UIkit.dropdown('#profile-dropdown').hide()
        if (window.location.pathname === routes.SHARE_RESOURCE) {
          if (this.getResourceDataAdded) {
            this.newRoute = routes.MANAGE_RESOURCES
            UIkit.modal('#leave-user-profile').show()
          } else {
            Router.push(routes.MANAGE_RESOURCES)
          }
        } else {
          Router.push(routes.MANAGE_RESOURCES)
        }
      },
      leavePage() {
        this.setResourceDataAdded(false)
        if (this.newRoute === routes.HOME) {
          this.$auth.id.signOut()
        }
        if (this.newRoute === routes.SHARE_RESOURCE) {
          setTimeout(() => {
            window.location.reload()
          }, 500)
        } else {
          setTimeout(() => {
            Router.push(this.newRoute)
          }, 500)
        }
      },
      profileHover(value) {
        if (value) {
          this.editIcon = iconUtil.resolve(misc.EDIT_PEN_HOVER)
        } else {
          this.editIcon = iconUtil.resolve(misc.EDIT_PEN)
        }
      },
      redirect(url, target) {
        window.open(url, target)
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../styles/colours.scss';
  @import '../../styles/breakpoints.scss';

  .debug-panel {
    background-color: #9cf196 !important;
  }

  .avatar-img {
    height: 38px;
    width: 38px;
    position: relative;
    right: 9px;
    border-radius: 50%;
    margin-top: -5px;

    &:hover {
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
    }
  }

  .avatar-img-default {
    background-color: $page-background-color;
  }

  .avatar-img-custom {
    border: solid 2px #f3f3f3;
  }

  .navbar-buttons {
    color: white;
    border: 1.6px solid white;
    padding: 0;
    font-size: 16px;
    line-height: 29px;
    height: 29px;
    border-radius: 1.6px;
    margin-bottom: 5px;
    background-color: rgba(255, 255, 255, 0.08);

    &:hover {
      border: solid 1.6px white;
      border-radius: 1.6px;
      background-color: white;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      color: $light-blue;
    }
  }

  .share-icon {
    padding-left: 16px;
    padding-right: 8px;
    padding-bottom: 3px;
  }

  .link-text {
    color: $font-color;
  }

  .share-btn-dimensions {
    height: 30px;
    margin-right: 19px;
    padding-right: 16px;
  }

  .signin-btn-dimensions {
    min-width: 92px;
    height: 30px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .uk-button {
    text-transform: none;
  }

  .uk-dropdown-nav {
    padding: 0px;
    font-family: Arial;
    font-size: 16px;
    font-weight: bold;

    .user-profile {
      padding: 17px 20px 17px 20px;
      background-color: $app-background;
      font-weight: 700;
      cursor: pointer;

      &:hover {
        .link-text {
          color: $light-blue;
        }

        .user-name {
          color: $light-blue;
        }
      }

      .user-name {
        color: $font-color;
        padding-bottom: 6px;
      }
    }
  }

  .menu-text {
    padding: 12px 20px 12px 20px;
    font-weight: 400;
  }


  .uk-dropdown {
    padding: 0px;

    li {
      a {
        color: $font-color;

        &:hover {
          color: $light-blue;
          font-weight: 400;
        }
      }
    }
  }

  .edit-icon {
    padding-left: 8px;
    padding-bottom: 3px;
  }

  @media screen and (max-width: $breakpoint-small) {
    .user-profile-dropdown {
      max-width: 250px;
    }
    .link-text {
      word-wrap: break-word;
      white-space: normal;
    }
    .avatar-img {
      right: 0;
    }
  }
</style>
